export const model = {
    id: null,
    name: '',
    is_active: 1,    
    created_at: '',
    updated_at: ''
};
